








import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryFinanceSalesStatList, ExportFinanceSalesStat } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

@Component({
  components: {
    VQuery,
    VTable,
  },
})
export default class FinanceSalesStatList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    statDateDaterange:[],
    orderBy: 'stat_date desc',
    statDateTimeScope:'',
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '统计日期', param: 'statDateDaterange', type: 'daterange' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '导出', type: 'warning', click: this.exportHandle }]
  // 数据表头 -
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '统计日期', param: 'statDate',width:120 },
    { title: '订单金额', param: 'orderAmount' },
    { title: '支付金额_销售额', param: 'payAmount' },
    { title: '支付优惠金额', param: 'paymentDiscountAmount' },
    { title: '微信支付销售额', param: 'wechatPayAmount' },
    { title: '微信小程序支付销售额', param: 'wechatMiniPayAmount' },
    { title: '支付宝支付销售额', param: 'alipayAmount' },
    { title: '银行卡支付销售额', param: 'bankCardAmount' },
    { title: '绿豆抵扣销售额', param: 'mungBeanAmount' },
    { title: '订单产生PV', param: 'orderPv' },
    { title: '订单产生原始PV', param: 'orderOrgPv' },
    { title: '入账时的订单PV', param: 'recordOrderPv' },
    { title: '入账时的平台PV', param: 'recordPlatformPv' },
    { title: '订单完成数', param: 'orderCount' },
    { title: '数据更新时间', param: 'updateTime', formatter: DateFormat,width:160 },
  ]

  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }
  private exportHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportFinanceSalesStat(param,"财务销售明细统计.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async created() {
    this.loadData()
  }


  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryFinanceSalesStatList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }
  private getRequestParam(){
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.statDateDaterange.length >0) {
      param.statDateTimeScope = DateFormat(param.statDateDaterange[0]) + ',' + DateFormat(param.statDateDaterange[1])
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
